<p>{{(dialogOperation === dlgOperationEnum.Rename ? 'FILENAMEDLG.RENAME' : 'FILENAMEDLG.NEWFOLDER') | translate}}</p>
<form [formGroup]="filenameForm">
  <input formControlName="filenameControl" 
  [value]="mimetype === mimeTypesEnum.Folder ? filename : (filename | removeExtensionString)" 
  type="text" class="filename-input" id="filename-input"/>
</form>

<div class="fr-float-left">
  <button class="cb-btn fa-pull-right" mat-dialog-close>{{'FILENAMEDLG.CANCEL' | translate}}</button>
  <button class="cb-btn fa-pull-right" (click)="closeDlg(filename)">
    {{(dialogOperation === dlgOperationEnum.Rename ? 'FILENAMEDLG.OK' : 'FILENAMEDLG.CREATE') | translate}}
  </button>
</div>

